module.exports = __webpack_public_path__ + "static/media/homeText.a3bfb2fd.md";